module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT6.309fe349.png";